interface Props { status: 'Active' | 'Ended'; }
export function StatusBadge({ status }: Props) {
  return status === 'Active'
    ? <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400">Active</span>
    : <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-400">Ended</span>;
}
